import { Shimmer } from '@tutero/ui';

/*
 * The admin's waits, in the design system's shimmer (`TShimmerBox`) as the detail pages draw
 * theirs: grey blocks where what is coming will land. The shell's `Loading` and the accounts'
 * `SectionWait` are built from these.
 */

/** Widths for a run of lines, so they read as words rather than bars. */
const WIDTHS = ['w-2/3', 'w-1/2', 'w-3/4', 'w-2/5', 'w-3/5', 'w-1/3'];

/** A few lines of text, each its own length; `count` of them. */
export function ShimmerLines({ count = 4 }: { count?: number }) {
  return (
    <div className="flex w-full flex-col gap-3 py-2">
      {Array.from({ length: count }, (_, at) => (
        <Shimmer key={at} className={`h-4 ${WIDTHS[at % WIDTHS.length]}`} />
      ))}
    </div>
  );
}

/** A list's table before its rows: the header, then rows of the list's own 40px height. */
export function TableShimmer({ rows = 10 }: { rows?: number }) {
  return (
    <div className="bg-background overflow-hidden rounded-lg border">
      <div className="flex h-9 items-center gap-6 border-b bg-neutral-50 px-4 dark:bg-neutral-900">
        <Shimmer className="h-3 w-40" />
        <Shimmer className="h-3 w-24" />
        <Shimmer className="hidden h-3 w-32 sm:block" />
        <Shimmer className="hidden h-3 w-20 md:block" />
      </div>
      <ShimmerRows rows={rows} />
    </div>
  );
}

/** Rows of a list's table, each a name and a few cells. */
function ShimmerRows({ rows = 3 }: { rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, at) => (
        <div
          key={at}
          className="flex h-10 items-center gap-6 border-b px-4 last:border-b-0"
        >
          <Shimmer className={`h-4 ${at % 2 ? 'w-32' : 'w-40'}`} />
          <Shimmer className="h-4 w-24" />
          <Shimmer className="hidden h-4 w-32 sm:block" />
          <Shimmer className="hidden h-4 w-20 md:block" />
        </div>
      ))}
    </>
  );
}
